import { render, staticRenderFns } from "./PetitionIDInputDialog.vue?vue&type=template&id=c1d23192&scoped=true&"
import script from "./PetitionIDInputDialog.vue?vue&type=script&lang=js&"
export * from "./PetitionIDInputDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d23192",
  null
  
)

export default component.exports